import { create, tsx } from '@dojo/framework/core/vdom';
import icache from '@dojo/framework/core/middleware/icache';
import has from '@dojo/framework/core/has';

import * as css from './Submit.m.css';
import Text from '../../widgets/Text';

interface NewsLetterSubmitProperties {
	email: string;
	_gotcha: string;
}

const factory = create({ icache }).properties<NewsLetterSubmitProperties>();

export const NewsLetterSubmit = factory(function NewsLetterSubmit({
	properties,
	middleware: { icache }
}) {
	const { email, _gotcha } = properties();

	if (has('build-time-render')) {
		return <div classes={[css.root]} />;
	}

	const requestSent = icache.getOrSet('request', async () => {
		if (_gotcha || !email) {
			return true;
		}
		const url =
			'https://script.google.com/macros/s/AKfycbxGw_dH7fz1iDh1A619ssMuXEkZX--5MsKTpIKUS_KSO9n-LyiX18zEhVDkCl-IXzoF/exec';

		const fields: { name: string; value: string }[] = [
			{ name: 'email', value: decodeURIComponent(email) }
		];
		const payload = JSON.stringify({
			submittedAt: Date.now(),
			context: {
				pageUri: window.parent.location.href,
				pageName: 'Sitepen Newsletter Sign-up'
			},
			fields
		});

		// Prefer sendBeacon for reliability on navigation
		if (navigator.sendBeacon) {
			const blob = new Blob([payload], {
				type: 'text/plain;charset=UTF-8'
			});
			navigator.sendBeacon(url, blob);
		} else {
			// Fallback: fire-and-forget fetch with no-cors
			fetch(url, {
				method: 'POST',
				mode: 'no-cors',
				headers: {
					'Content-Type': 'text/plain;charset=UTF-8'
				},
				body: payload
			}).catch(() => {
				icache.set('submitError', true);
			});
		}
		return true;
	});

	if (requestSent) {
		return (
			<div classes={[css.root]}>
				<Text type="large-body" responsive="body" align="center" bold>
					Thanks for Signing Up!
				</Text>
			</div>
		);
	}
});

export default NewsLetterSubmit;
